import { render, staticRenderFns } from "./notifications-menu.vue?vue&type=template&id=74155b76"
import script from "./notifications-menu.vue?vue&type=script&lang=js"
export * from "./notifications-menu.vue?vue&type=script&lang=js"
import style0 from "./notifications-menu.vue?vue&type=style&index=0&id=74155b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports